import script from "./HrRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./HrRadio.vue?vue&type=script&setup=true&lang=js"

import "./HrRadio.vue?vue&type=style&index=0&id=15aa0e40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15aa0e40"]])

export default __exports__
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QRadio});
